import { render, staticRenderFns } from "./CleanUpHistory.vue?vue&type=template&id=605c24ec"
import script from "./CleanUpHistory.vue?vue&type=script&lang=js"
export * from "./CleanUpHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports